export const yearMonthFormat = 'yyyy-MM';
export const dateFormat = 'yyyy-MM-dd';
export const dateTimeFormat = 'yyyy-MM-dd / HH:mm:ss';
